import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createBlock(_component_Multiselect, {
    class: "multiselect-categories",
    mode: "multiple",
    valueProp: "id",
    "track-by": "id",
    groups: true,
    groupLabel: "label",
    groupOptions: "children",
    hideSelected: false,
    filterResults: false,
    searchable: true,
    options: _ctx.getOptions,
    delay: 300,
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    "can-clear": true,
    multipleLabel: function (value) {
      return `${value.length} kategorier valgt`;
    },
    closeOnSelect: true
  }, null, 8, ["options", "modelValue", "multipleLabel"]))
}